import { Request, AnonymusRequest } from "./HttpService";
import FileService from "./FileService";
import { translateAndSortAscendant } from "../common/helper";
import { showError } from "./ModalService";
function serializeObject(object) {
  let serialized = "";

  for (let key in object) {
    if (object[key] || object[key] === 0)
      if (key === "languageLevels") {
        object[key].forEach((item) => {
          serialized = `${serialized}${key}=${encodeURIComponent(item.id)}&`;
        });
      } else
        serialized = `${serialized}${key}=${encodeURIComponent(object[key])}&`;
  }
  return serialized;
}
export const DOCOnlineService = {
  getAllJobRoles: function () {
    return Request(
      "doconline/DOCPersonalInformation/GetAllJobRoles",
      "GET"
    ).then((data) => {
      return translateAndSortAscendant(data, "description");
    });
  },

  getlAllLanguages: function () {
    return Request("doconline/DOCEducation/Language", "GET").then((data) => {
      return translateAndSortAscendant(data, "description");
    });
  },

  getlAllZonesByCompany: function (companyId) {
    let url = `doconline/DOCPersonalInformation/GetAllZonesByCompany/${companyId}`;
    return Request(url, "GET");
  },

  getAllLanguageLevels: function () {
    return Request("doconline/DOCEducation/LanguageLevel", "GET").then(
      (data) => {
        return translateAndSortAscendant(data, "description");
      }
    );
  },

  getCourses: function (pageSize, pageNumber, searchData) {
    let url = `doconline/DOCEducation/SearchCourses/${pageSize}/${pageNumber}`;
    if (searchData !== undefined) {
      url = url + `?query=${searchData}`;
    }
    return Request(url, "GET");
  },

  getSchools: function (pageSize, pageNumber, searchData) {
    let url = `doconline/DOCEducation/SearchSchools/${pageSize}/${pageNumber}`;
    if (searchData !== undefined) {
      url = url + `?query=${searchData}`;
    }
    return Request(url, "GET");
  },

  getDocOnlineByToken: function (token) {
    let url = `doconline/DOCGeneral/${token}`;
    return new Promise((resolve, reject) => {
      Request(url, "GET", null, (err) => {
        console.error(err);
        reject(err);
      }).then((data) => {
        resolve(data);
      });
    });
  },

  getDocOnlineRGPD: function (companyId, generatedLanguageInitials) {
    let url = `doconline/DOCGeneral/GetRGPD/${companyId}/${generatedLanguageInitials}`;
    return new Promise((resolve, reject) => {
      Request(url, "GET", null, (err) => {
        console.error(err);
        reject(err);
      }).then((data) => {
        resolve(data);
      });
    });
  },

  getDocOnlinePrivacyPolicy: function (companyId, generatedLanguageInitials) {
    let url = `doconline/DOCGeneral/GetPrivacyPolicy/${companyId}/${generatedLanguageInitials}`;
    return new Promise((resolve, reject) => {
      Request(url, "GET", null, (err) => {
        console.error(err);
        reject(err);
      }).then((data) => {
        resolve(data);
      });
    });
  },

  AcceptRGPD: function (token) {
    let url = "doconline/DOCGeneral/AcceptRGPD";
    return Request(url, "PUT", token);
  },

  Submit: function (docOnline) {
    let url = "doconline/DOCGeneral/Submit";
    return Request(url, "PUT", docOnline);
  },
  GetAllSkillLevels() {
    let url = "doconline/DOCSkillLevel";
    return Request(url, "GET");
  },
  getAllYearsExperience() {
    return Request("doconline/DOCSkillExperienceTime", "GET");
  },
  getTechSkills(companyId) {
    return Request(`doconline/DocTechnology/${companyId}/`, "GET").then(
      (data) => {
        return translateAndSortAscendant(data, "description");
      }
    );
  },
  getDocOnlineById: function (docOnlineId) {
    let url = `vitae/EditDocOnline/GetById/${docOnlineId}`;
    return new Promise((resolve, reject) => {
      Request(url, "GET", null, (err) => {
        console.error(err);
        reject(err);
      }).then((data) => {
        resolve(data);
      });
    });
  },
  EditDocOnline: function (docOnline, interviewId, docOnlineLanguageId) {
    let url = "vitae/EditDocOnline/Save";
    if (interviewId) {
      url = `vitae/EditDocOnline/Save/${docOnlineLanguageId}/${interviewId}`;
    }
    return Request(url, "PUT", docOnline);
  },
  SaveAsDocOnline: function (docOnline) {
    let url = "vitae/EditDocOnline/SaveAs";
    return Request(url, "PUT", docOnline);
  },

  downloadDocOnline: function (
    docOnlineId,
    companyId,
    languageId,
    downloadIsInPdf,
    fileName,
    file
  ) {
    let url = `vitae/EditDocOnline/Download/${docOnlineId}/${companyId}/${languageId}/${downloadIsInPdf}`;
    return FileService.Download(url, fileName, downloadIsInPdf, file);
  },
  generateUrl(langCode, companyId, docOnlineId) {
    let url = "";
    if (!companyId)
      url = `doconline/documents/GenerateSharedURl/${langCode}/${docOnlineId}`;
    else
      url = `doconline/documents/GenerateSharedURl/${langCode}/${companyId}/${docOnlineId}`;
    return Request(url, "GET");
  },
  hasWebView() {
    return Request("doconline/documents/webview", "GET");
  },
  getAllTemplates() {
    return Request("vitae/EditDocOnline/template", "GET");
  },
  getVitaeLanguages: function () {
    return Request("vitae/general/getVitaeLanguages", "GET");
  },
  getAllCompaniesWebDocs: function () {
    return Request("vitae/company/webDocs", "GET");
  },
  getDocs(pageSize, pageNumber, searchData) {
    let url = `vitae/EditDocOnline/${pageSize}/${pageNumber}`;
    if (searchData !== undefined) {
      url = url + `?${serializeObject(searchData)}`;
    }
    return Request(url, "GET");
  }
};

export function ConsultantDocOnlineService(docOnlineticket) {
  return {
    saveAs: function (docOnline) {
      let url = `dwork/ConsultantDocOnlineManagement/saveAs/${docOnlineticket}`;
      return AnonymusRequest(url, "PUT", docOnline);
    },
    save: function (docOnline) {
      let url = `dwork/ConsultantDocOnlineManagement/save/${docOnlineticket}`;
      return AnonymusRequest(url, "PUT", docOnline);
    },
    getConsultantDocOnline() {
      return AnonymusRequest(
        `dwork/ConsultantDocOnlineManagement/doc/${docOnlineticket}`,
        "GET"
      );
    },
    generateUrl(langCode, companyId) {
      if (!companyId) {
        showError("Company is required");
        return;
      }
      return AnonymusRequest(
        `dwork/ConsultantDocOnlineManagement/GenerateSharedURl/${langCode}/${companyId}/${docOnlineticket}`,
        "GET"
      );
    },
    downloadDocOnline(templatePrefix, languageCode, downloadIsInPdf, fileName) {
      let url = `dwork/ConsultantDocOnlineManagement/Download/${docOnlineticket}/${templatePrefix}/${languageCode}/${downloadIsInPdf}`;

      return FileService.Download(url, fileName, downloadIsInPdf);
    },
    getAllJobRoles: function () {
      return AnonymusRequest(
        "dwork/doconline/DOCPersonalInformation/GetAllJobRoles",
        "GET"
      ).then((data) => {
        return translateAndSortAscendant(data, "description");
      });
    },

    getlAllLanguages: function () {
      return AnonymusRequest(
        `dwork/doconline/Language/${docOnlineticket}`,
        "GET"
      ).then((data) => {
        return translateAndSortAscendant(data, "description");
      });
    },

    getlAllZonesByCompany: function (companyId) {
      let url = `dwork/doconline/GetAllZonesByCompany/${companyId}/${docOnlineticket}`;
      return AnonymusRequest(url, "GET");
    },

    getAllLanguageLevels: function () {
      return AnonymusRequest(
        `dwork/doconline/LanguageLevel/${docOnlineticket}`,
        "GET"
      ).then((data) => {
        return translateAndSortAscendant(data, "description");
      });
    },

    getCourses: function (pageSize, pageNumber, searchData) {
      let url = `doconline/DOCEducation/SearchCourses/${pageSize}/${pageNumber}`;
      if (searchData !== undefined) {
        url = url + `?query=${searchData}`;
      }
      return AnonymusRequest(url, "GET");
    },

    getSchools: function (pageSize, pageNumber, searchData) {
      let url = `doconline/DOCEducation/SearchSchools/${pageSize}/${pageNumber}`;
      if (searchData !== undefined) {
        url = url + `?query=${searchData}`;
      }
      return AnonymusRequest(url, "GET");
    },
    hasWebView() {
      return AnonymusRequest(
        `dwork/doconline/webview/${docOnlineticket}`,
        "GET"
      );
    },
    getAllTemplates() {
      return AnonymusRequest(
        `dwork/doconline/template/${docOnlineticket}`,
        "GET"
      );
    },
    getConsultantDocOnline() {
      return AnonymusRequest(
        `dwork/ConsultantDocOnlineManagement/doc/${docOnlineticket}`,
        "GET"
      );
    },
    getAllYearsExperience() {
      return AnonymusRequest(
        `dwork/doconline/experienceTime/${docOnlineticket}`,
        "GET"
      );
    },
    GetAllSkillLevels() {
      let url = `dwork/doconline/skillLevel/${docOnlineticket}`;
      return AnonymusRequest(url, "GET");
    },
    getAllTemplates() {
      return AnonymusRequest(
        `dwork/doconline/template/${docOnlineticket}`,
        "GET"
      );
    },
    getVitaeLanguages: function () {
      return AnonymusRequest(
        `dwork/doconline/getVitaeLanguages/${docOnlineticket}`,
        "GET"
      );
    },
    getAllCompaniesWebDocs: function () {
      return AnonymusRequest(
        `dwork/docOnline/webDocs/${docOnlineticket}`,
        "GET"
      );
    }
  };
}
